export enum VerificationDecision {
  Approve = "approve",
  Decline = "decline"
}
export enum RejectionReasons {
  Safety = "Minor safety",
  Nudity = "Adult nudity and sexual activities",
  Bulling = "Bulling and harassment",
  Illegal = "Illegal activities and regulated goods",
  Other = "Other"
}
